import styles from "./styles.module.scss";

import type { RatingsJSONSchema } from "../../../../types";
import Selections from "../selections";
import { useBlockType } from "../../contexts/BlockTypeContext";
import getClasses from "utils/getClasses";
import CustomSelectionControl from "components/custom-selection-control/CustomSelectionControl";

const MAX_COLS_COUNT = 7;
type Props = {
  jsonSchema: RatingsJSONSchema;
  onChangeJsonSchema: (arg: RatingsJSONSchema) => void;
  suicidal?: boolean;
  gptBusy?: boolean;
};

const Ratings = ({
  jsonSchema,
  onChangeJsonSchema,
  suicidal,
  gptBusy,
}: Props) => {
  const { isEdit, onChange, value } = useBlockType();

  const onChangeOptions = (value: string[], prop: "rows" | "cols") => {
    onChangeJsonSchema({
      ...jsonSchema,
      properties: {
        ...jsonSchema.properties,
        [prop]: {
          ...jsonSchema.properties[prop],
          enum: value,
        },
      },
    });
  };

  return isEdit ? (
    <div className={styles["ratings"]}>
      <div className={styles["ratings__col"]}>
        <div className={styles["ratings__header"]}>
          {jsonSchema.properties?.rows?.title}
        </div>
        <Selections
          type={undefined}
          options={jsonSchema.properties?.rows?.enum}
          onChangeOptions={(v) => onChangeOptions(v, "rows")}
          showIndex
          addProp={"Row"}
        />
      </div>

      <div className={styles["ratings__col"]}>
        <div className={styles["ratings__header"]}>
          {jsonSchema.properties?.cols?.title}
        </div>
        <Selections
          options={jsonSchema.properties?.cols?.enum}
          onChangeOptions={(v) => onChangeOptions(v, "cols")}
          type={"checkbox"}
          count={MAX_COLS_COUNT}
          addProp={"Column"}
        />
      </div>
    </div>
  ) : (
    <table className={styles["ratings__table"]}>
      <thead>
        <tr className={styles["ratings__table-row"]}>
          <th
            className={getClasses(
              styles["ratings__table-cell"],
              jsonSchema.properties?.cols?.enum.length >= 3 &&
                styles["ratings__table-cell-leading--25"],
            )}
          />
          {jsonSchema.properties?.cols?.enum.map((col, j) => (
            <th key={j} className={styles["ratings__table-cell"]}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      {/* body row */}
      <tbody>
        {(jsonSchema.properties?.rows?.enum || []).map((row, i) => (
          <tr
            key={row}
            className={getClasses(
              styles["ratings__table-row"],
              styles["ratings__table-row--body"],
            )}
          >
            <td
              className={getClasses(
                styles["ratings__table-cell"],
                i === 8 && suicidal && "red",
              )}
            >
              {i + 1 + ". " + row}
            </td>
            {jsonSchema.properties?.cols?.enum.map((col, j) => (
              <td key={j} className={styles["ratings__table-cell"]}>
                <CustomSelectionControl
                  type={"radio"}
                  disabled={gptBusy}
                  checked={value && value[row] === col}
                  onChange={() =>
                    onChange &&
                    onChange({
                      ...value,
                      [row]: col,
                    })
                  }
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Ratings;
